import React, { useState } from 'react';
import { CheckCircle2, Image, MessageSquare, X } from 'lucide-react';

const TopupValidationModal = ({ isOpen, onClose, onValidate, order }) => {
  const [note, setNote] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setNote('');
    setImageUrl('');
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setIsSubmitting(true);
      const result = await onValidate(order.id, 'completed', note.trim(), imageUrl.trim());
      if (result !== null) {
        handleClose();
      }
    } catch (error) {
      console.error('Erreur lors de la validation Topup:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen || !order) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-3xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-slate-200 p-6">
          <div className="flex items-center gap-3">
            <div className="rounded-2xl bg-emerald-100 p-3 text-emerald-600">
              <CheckCircle2 className="h-6 w-6" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-slate-900">Valider la commande</h2>
              <p className="text-sm text-slate-500">{order.productName} - {order.offerValue || order.offerName}</p>
            </div>
          </div>

          <button
            type="button"
            onClick={handleClose}
            className="rounded-xl p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 p-6">
          <div className="rounded-2xl bg-slate-50 p-4">
            <h3 className="mb-2 text-sm font-semibold text-slate-900">Details de la commande</h3>
            <div className="space-y-1 text-sm text-slate-600">
              <p><span className="font-medium">Revendeur:</span> {order.resellerName}</p>
              <p><span className="font-medium">Offre:</span> {order.offerValue || order.offerName}</p>
              <p><span className="font-medium">Montant:</span> {Number(order.price || 0).toLocaleString('fr-FR')} DA</p>
            </div>
          </div>

          <div>
            <label className="mb-2 flex items-center gap-2 text-sm font-medium text-slate-700">
              <Image className="h-4 w-4" />
              <span>Lien de la capture de preuve</span>
            </label>
            <input
              type="url"
              value={imageUrl}
              onChange={(event) => setImageUrl(event.target.value)}
              placeholder="https://..."
              className="w-full rounded-2xl border border-slate-300 px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-emerald-400 focus:ring-4 focus:ring-emerald-50"
            />
            <p className="mt-1 text-xs text-slate-500">
              Optionnel. Collez le lien ImgBB ou un autre hebergement d image si vous voulez joindre une preuve.
            </p>
          </div>

          <div>
            <label className="mb-2 flex items-center gap-2 text-sm font-medium text-slate-700">
              <MessageSquare className="h-4 w-4" />
              <span>Note admin</span>
            </label>
            <textarea
              rows={3}
              value={note}
              onChange={(event) => setNote(event.target.value)}
              placeholder="Commentaire optionnel pour le revendeur..."
              className="w-full resize-none rounded-2xl border border-slate-300 px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-emerald-400 focus:ring-4 focus:ring-emerald-50"
            />
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={handleClose}
              className="rounded-2xl bg-slate-100 px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {isSubmitting ? 'Validation...' : 'Valider la commande'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TopupValidationModal;
